import { createContext, useState } from 'react';
import api from 'services/api';
import moment from 'moment';

const filter = {
  like: '',
  id: '',
  entidade: [],
  dtvenc: {
    i: null,
    f: null,
  },
  dtlanc: {
    i: moment().subtract(10, 'days').format('YYYY-MM-DD'),
    f: null,
  },
  valor: '',
  vendedor: [],
  filial: [],
  dtemissao: {
    i: null,
    f: null,
  },
  observacao: '',
  banco: [],
  agencia: '',
  conta: '',
  cheque: '',
  nome: '',
  alinea: [],
};

export const ChequesBaixadosContext = createContext();

export const ChequesBaixadosProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [chequesBaixados, setChequesBaixados] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getChequesBaixados = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: chequesBaixados?.filter,
        page: chequesBaixados?.page,
        size: chequesBaixados?.size,
        order: chequesBaixados?.order,
        ...payload,
      });
      setChequesBaixados((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ChequesBaixadosContext.Provider
      value={{
        getLoading,
        getChequesBaixados,
        chequesBaixados,
      }}
    >
      {children}
    </ChequesBaixadosContext.Provider>
  );
};
